var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDominicanrepublic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_8526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.413391 15.1305C1.52142 19.2415 4.75847 22.4786 8.86959 23.5867V15.1305H0.413391Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.86955 0.413391C4.75847 1.52138 1.52138 4.75847 0.413391 8.86955H8.86959V0.413391H8.86955Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5866 8.86955C22.4786 4.75847 19.2415 1.52138 15.1304 0.413391V8.86959H23.5866V8.86955Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1304 23.5866C19.2415 22.4786 22.4786 19.2415 23.5866 15.1304H15.1304V23.5866Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1305 12C15.1305 13.7289 13.729 15.1304 12 15.1304C10.2711 15.1304 8.86957 13.7289 8.86957 12C8.86957 10.2711 12 8.86954 12 8.86954C12 8.86954 15.1305 10.2711 15.1305 12Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.86957 12C8.86957 10.2711 10.2711 8.86954 12 8.86954C13.729 8.86954 15.1305 10.2711 15.1305 12",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2391 10.4348V12.3913C10.2391 13.3638 11.0275 14.1522 12 14.1522C12.9725 14.1522 13.7609 13.3638 13.7609 12.3913V10.4348H10.2391Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_8526"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDominicanrepublic);
export default __webpack_public_path__ + "static/media/dominicanrepublic.8fcb5a56c23672af0017a403cab04b2b.svg";
export { ForwardRef as ReactComponent };